<template>
  <main>
    <v-alert v-if="carbon.totalCarbonEmmision" type="info">
      <main class="tw-flex tw-flex-wrap tw-justify-between">
        <span>Total Carbon Emmision: {{ carbon.totalCarbonEmmision }}</span>
        <span>Total Carbon Offset: {{ carbon.totalCarbonOffset }}</span>
      </main>
    </v-alert>
  </main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      projects: [],
      loading: false,
      errors: {},
      disabled: false,
      user: {},
      carbon: null,
      token: ""
    };
  },
  components: {},

  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.getCarbon();
    console.log(this.carbon);
  },
  methods: {
    getCarbon() {
      axios
        .get(`${this.$baseUrl}/carbon/offset/get/${this.user._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.carbon = response.data.carbon[0];
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
